export default function Grid(theme) {
  return {
    MuiGrid: {
      styleOverrides: {
        root: {
          '&.MuiGrid-container': {
            width: '100%',
            // Only on small mobile (phones): remove negative margin and item left padding so containers stay aligned
            [theme.breakpoints.down('sm')]: {
              margin: 0,
              '& > .MuiGrid-item': {
                paddingLeft: 0,
              },
            },
          },
        },
      },
    },
  };
}

